/* eslint-disable linebreak-style */
import get from 'lodash/get';
import {
  FETCH_PROJECTS,
  SET_PROJECTS,
  SET_PROJECT_FAILURE,
  SUBMIT_PROJECT,
  UPDATE_PROJECT,
  SET_PROJECT_ADD,
  SET_PROJECT_UPDATE,
} from '../types';

const normalizeProjectConfig = (config) => {
  if (config == null) return {};
  if (typeof config === 'string') {
    try {
      const parsed = config.trim() ? JSON.parse(config) : {};
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
  if (typeof config === 'object' && !Array.isArray(config)) return { ...config };
  return {};
};

const initialState = {
  isProjectLoading: false,
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECTS: {
      const Projects = get(action, ['response', 'data'], []);
      const projectData = [];
      for (let i = 0; i < Projects.length; i += 1) {
        const id = get(Projects[i], 'id', 0);
        const projectName = get(Projects[i], 'projectName', '');
        const projectId = get(Projects[i], 'projectId', '');
        const manager = get(Projects[i], 'manager', '');
        const startDate = get(Projects[i], 'startDate', '');
        const contractId = get(Projects[i], 'contractId', '');
        const pihRefId = get(Projects[i], 'pihRefId', '');
        const contractor = get(Projects[i], 'contractor', '');
        const location = get(Projects[i], 'location', '');
        const clientId = get(Projects[i], 'clientId', 0);
        const clientName = get(Projects[i], 'clientName', '');
        const endDate = get(Projects[i], 'endDate', '');
        const config = normalizeProjectConfig(get(Projects[i], 'config', ''));
        const members = get(Projects[i], 'teamMembers', '');
        const isGuestUser = get(Projects[i], 'isGuestUser', '');
        const selectedTabs = get(Projects[i], 'selectedTabs', '');
        const projectStatus = get(Projects[i], 'projectStatus', '');
        const projectType = get(Projects[i], 'projectType', null);
        const finalClient = get(Projects[i], 'finalClient', null);
        const ndtType = get(Projects[i], 'ndtType', null);
        if (projectId !== '') {
          projectData[i] = {
            clientId,
            clientName,
            contractId,
            contractor,
            endDate,
            id,
            location,
            manager,
            pihRefId,
            projectId,
            projectName,
            startDate,
            config,
            projectStatus,
            projectType,
            finalClient,
            ndtType,
            members,
            isGuestUser,
            selectedTabs,
          };
        }
      }

      return {
        ...state,
        projectData,
        isProjectLoading: false,
      };
    }

    case FETCH_PROJECTS: {
      return {
        ...state,
        isProjectLoading: true,
      };
    }

    case SET_PROJECT_FAILURE: {
      return {
        ...state,
        isProjectLoading: false,
      };
    }

    case SUBMIT_PROJECT: {
      return {
        ...state,
        isProjectLoading: true,
      };
    }

    case UPDATE_PROJECT: {
      return {
        ...state,
      };
    }

    case SET_PROJECT_ADD: {
      const projectArr = get(action, 'responseData', {});
      const clientName = get(action, 'clientName', {});
      const projData = get(state, 'projectData', []);
      projectArr.clientName = clientName;
      if (projectArr.config !== undefined) {
        projectArr.config = normalizeProjectConfig(projectArr.config);
      }
      const newData = [...projData, projectArr];
      return {
        ...state,
        projectData: newData,
        isProjectLoading: false,
      };
    }

    case SET_PROJECT_UPDATE: {
      const projectArr = get(action, 'responseData', {});
      const id = get(action, 'id', {});
      const projData = get(state, 'projectData', []);

      var objIndex = projData.findIndex((obj) => obj.id == id);
      //Update object's property.
      if (objIndex >= 0) {
        projData[objIndex].startDate = projectArr.startDate ?? projData[objIndex].startDate;
        projData[objIndex].endDate = projectArr.endDate ?? projData[objIndex].endDate;
        if (projectArr.config !== undefined) {
          const prevObj = normalizeProjectConfig(projData[objIndex].config);
          const incoming = normalizeProjectConfig(projectArr.config);
          projData[objIndex].config = { ...prevObj, ...incoming };
        }
        projData[objIndex].projectStatus = projectArr.projectStatus ?? projData[objIndex].projectStatus;
        if (projectArr.projectType !== undefined) {
          projData[objIndex].projectType = projectArr.projectType;
        }
        if (projectArr.finalClient !== undefined) {
          projData[objIndex].finalClient = projectArr.finalClient;
        }
        if (projectArr.ndtType !== undefined) {
          projData[objIndex].ndtType = projectArr.ndtType;
        }
      }
      const newData = [...projData];
      return {
        ...state,
        projectData: newData,
        isProjectLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default projectReducer;
